import styled from "styled-components";

const Btn = styled.button`
  color: white;
  font-size: 1.1em;
  font-weight: bold;
  background-color: #ffbf1d;
  overflow: hidden;
  width: 132px;
  height: 40px;
  border-radius: 8px;
`;

export default Btn;
